import { createTheme } from "@mantine/core";

export const theme = createTheme({
	colors: {
		myColor: ["#ffebff", "#f5d5fb", "#e6a8f3", "#d779eb", "#cb51e4", "#c337e0", "#c02adf", "#a91cc6", "#9715b1", "#84099c"],
	},
	fontFamily: "Roboto, sans-serif",
});
